module.exports = __webpack_public_path__ + "img/orange_julius.2297394c.jpg";